import Component from 'vue-class-component';
import ProductListElementAbstract from '../ProductAbstract/ProductListElementAbstract';
import ProductPhotosDownload from '@/components/ProductPhotosDownload/ProductPhotosDownload';

@Component({
    components: {
        ProductPhotosDownload,
    },
})
export default class ProductGridElement extends ProductListElementAbstract {
    
}

